import { useCallback } from "react";

import { SECONDARY_OVERLAY_QUERY_PARAM, SecondaryOverlayType } from "components/constants";
import { useIsXlOrLarger } from "mds/hooks/use-responsive";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectQueryString } from "store/selectors/view";
import { localStateActions } from "store/slices/local";
import { useQueryParamsActions } from "utils/routing";

export const useOverlayControls = (panelName: SecondaryOverlayType) => {
  const dispatch = useAppDispatch();
  const canShowBothSidebars = useIsXlOrLarger();
  const { setQueryParams, deleteQueryParams } = useQueryParamsActions();
  // Boolean equality — opening a different overlay must not wake consumers of this panel.
  const isSelected = useAppSelector(
    (state) =>
      new URLSearchParams(selectQueryString(state)).get(SECONDARY_OVERLAY_QUERY_PARAM) ===
      panelName,
  );

  const togglePanel = useCallback(() => {
    if (isSelected) {
      deleteQueryParams([[SECONDARY_OVERLAY_QUERY_PARAM, panelName]]);
    } else {
      if (!canShowBothSidebars) {
        dispatch(localStateActions.setIsSidebarOpen(false));
      }
      setQueryParams({ [SECONDARY_OVERLAY_QUERY_PARAM]: panelName });
    }
  }, [panelName, isSelected, deleteQueryParams, setQueryParams, canShowBothSidebars, dispatch]);

  return { isSelected, togglePanel };
};
